import {
  Carousel as CusCarousel,
  Autoplay,
  AutoplayOptionsType,
  CarouselContent,
  CarouselPrevious,
  CarouselNext,
  useCarousel,
  useDotButton,
  useSelectedSnapDisplay,
  SupCarousel,
} from "@repo/ui/components/carousel";
import { cn } from "@repo/ui/lib/utils";
import { useCallback, useEffect } from 'react';

interface ICusCarousel extends React.ComponentProps<typeof CusCarousel> {
  children: React.ReactNode;
  scroll?: boolean;
  className?: string;
  slides?: React.ReactElement[];
  userOptions?: AutoplayOptionsType;
  primary?: boolean;
  showDot?: boolean;
  propsContent?: React.ComponentProps<"div">;
  slotSnapDisplay?: React.ReactNode;
  slotScrollSnaps?: React.ReactNode;
}


export function ScrollSnaps({className}: {className?: string}) {
  const { api } = useCarousel();
  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(api);
  return (
    <div className={cn("embla__dots", className)}>
      {scrollSnaps.map((_, index) => (
        <button
          key={index}
          onClick={() => onDotButtonClick(index)}
          className={cn(
            "embla__dot",
            index === selectedIndex ? "embla__dot--selected" : ""
          )}
        />
      ))}
    </div>
  );
}
export function SelectedSnapDisplay({
  className,
  // children,
}: {
  className?: string;
  // children: React.ReactNode;
}) {
  const { api } = useCarousel();
  const { selectedSnap, snapCount } = useSelectedSnapDisplay(api);

  return (
    <div className={cn("embla__selected-snap-display", className)}>
      {selectedSnap + 1} / {snapCount}
    </div>
  );
}



function Carousel({
  children,
  scroll,
  className,
  opts,
  primary,
  slides,
  userOptions = {
    playOnInit: false,
  },
  showDot,
  propsContent,
  slotScrollSnaps,
  slotSnapDisplay,
}: ICusCarousel) {
  return (
    <CusCarousel
      className={cn("mx-auto w-full", className)}
      opts={{
        inViewThreshold: 1,
        ...opts,
      }}
      plugins={[Autoplay({ ...userOptions })]}
    >
      <CarouselContent {...propsContent}>{children}</CarouselContent>
      {scroll && (
        <>
          <CarouselPrevious
            className={cn(primary ? "bg-primary" : " bg-green-50")}
          />
          <CarouselNext className=" bg-green-50" />
        </>
      )}
      {showDot && <ScrollSnaps />}
      {slotScrollSnaps}
      {slotSnapDisplay}
      {slides && <SupCarousel slides={slides} />}
    </CusCarousel>
  );
}

export default Carousel;
